import React from 'react';
import { Container } from 'reactstrap';
import {
    DashboardPageHeader,
    ComingSoonCard,
    ModuleLandingGrid,
    ModuleShortcutCard,
} from '../../Components/Common/DashboardKit';

/**
 * Production module landing page.
 *
 * UI-only refactor (Pass 1):
 *  - Swapped video <ComingSoon> for <ComingSoonCard>.
 *  - Added a shortcut to the existing Display Boards route (live
 *    shop-floor status) — that route already exists; we're just
 *    making it easier to find.
 *  - Removed unused imports.
 *
 * Route is wrapped in <RoleProtected requireManager> in allRoutes.js.
 */
const Production = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-tools-line"
                        eyebrow="Shop Floor"
                        title="Production"
                        subtitle="Shop floor activity and run-rate insights"
                        tone="teal"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Production" },
                        ]}
                    />

                    <ModuleLandingGrid
                        title="Live boards"
                        icon="ri-tv-2-line"
                        description="Real-time shop-floor status"
                    >
                        <ModuleShortcutCard
                            icon="ri-tv-2-line"
                            label="Display Boards"
                            subtitle="Live CNC, Winding, Production-Flex, and Quality boards"
                            tone="success"
                            to="/display-boards"
                        />
                    </ModuleLandingGrid>

                    <ComingSoonCard
                        icon="ri-tools-line"
                        title="Production analytics are coming soon"
                        message="Run-rate analysis, downtime reports, and shift summaries will land here. Use the Display Boards link above for live status today."
                        tone="success"
                        features={[
                            "Hourly run-rate by machine",
                            "Downtime cause analysis",
                            "Shift handoff summaries",
                            "OEE rollups",
                        ]}
                        contact="Reach out to Production for ETA updates."
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Production;
